import React, { Component } from "react";
import { connect } from "react-redux";
import Config from "../../../../config/config";
import { Button, TextField, Box, Theme, Grid, Typography } from '@material-ui/core/';
import { Link } from "react-router-dom";
import * as actions from "../../../../store/actions/index";
import ValidateForm from "../../../../helper/validations";
import Messages from "../../../../helper/messages";
import Recaptcha from 'react-invisible-recaptcha';
import { withStyles } from '@material-ui/core/styles'
import {Styles} from "@material-ui/core/styles/withStyles";
import Alert from '@material-ui/lab/Alert';
import ReactHtmlParser from "react-html-parser"
import CircularProgress from '@material-ui/core/CircularProgress';
import {Helmet} from "react-helmet";
import clsx from 'clsx';

const useStyles: Styles<Theme, any, any> = () =>({
  appBar: {
    position: 'relative',
    background: 'none',
    boxShadow: 'none',
  },
  toolBar: {
    minHeight: 50,
  },
  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop:"20px",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#fdca42',
    width: '100vw',

    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
  label: {
    color: '#19191e',
    "&$focusedLabel": {
      color: "#6667AB"
    },
    "&$erroredLabel": {
      color: "#6667AB"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#19191e',
    "&$error:after": {
      borderBottomColor: "#6667AB"
    },
    "&:after": {
      borderBottom: `2px solid #6667AB`
    }
  },

  //general
  textCenter: {
    textAlign: 'center',
    color: '#19191e'
  },
  headline: {
    '@media (max-width: 960px)': {
      fontSize: '3.5rem',
    },
    '@media (max-width: 600px)': {
      fontSize: '2.5rem',
    },
  },
  logoFont: {
    fontFamily: 'Pacifico',
    color: '#6667AB'
  },

  //for page 1
  registerLogo:{
    width:"280px",
    height:"41px",
    '@media (max-width: 768px)': {
      width:"100%"
    },
  },
  description_title:{
    textAlign:"center",
    font: "normal normal bold 36px/26px Spartan-bold",
    color: "#19191e",
    opacity: "1",
    margin:"10px 0 10px 0"
  },

  //-----for page 2
  registerlogo2container:{
    textAlign:"left", 
    marginTop:"22px", 
    marginLeft:"40px",
    '@media (max-width: 768px)': {
      margin:"0 auto",
      textAlign:"center", 
      marginTop: "20px",
      width:"100%"
    },
  },
  registerLogo2:{
    width: "188px",
    height: "27px",
    '@media (max-width: 768px)': {
      width:"100%"
    },
  },
  description_title2:{
    textAlign:"center",
    font: "normal normal 14px/26px Roboto",
    color: "#19191e",
    opacity: "1",
    marginBottom: "10px"
  },
  description:{
    textAlign: "center",
    font: "normal normal normal 15px/32px Roboto",
    color: "#19191e",
    margin:"0 auto"
  },
  description2:{
    textAlign:"center",
    font: "normal normal bold 15px/26px Roboto",
    color: "#19191e",
    opacity: "1",
    marginBottom: "10px"
  },
  layout2: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '0',
    paddingRight: '0',
    paddingTop:"10px",
    display: 'flex',
    justifyContent: 'center',
    textAlign:"center",
    minHeight: `calc(100% - 361px)`,
    alignItems: 'center',
  },
  gotologin:{
    textAlign:"center",
    color: "#19191e",
    font: "normal normal bold 18px/26px Roboto",
  },
  resendlink:{
    font: "normal normal bold 18px/26px Roboto",
    color: "#6667AB",
    marginTop:"0",
    cursor:"pointer",
    marginBottom:"0",
    textDecoration:"underline"
  },
  mainDescription:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  resetBtn: {
    margin: '30px 0',
    color: '#6667AB',
    border: '1px solid rgba(102, 103, 171, 0.5)',
    '&:hover': {
			border: '1px solid #6667AB',
      backgroundColor: 'rgba(102, 103, 171, 0.2)'
		},
  },
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actionButtons: {
    minWidth: '460px',
    marginBottom: '20px',
    '@media (max-width: 760px)': {
      minWidth: '250px'
    },
    color: '#6667AB',
    border: '1px solid rgba(102, 103, 171, 0.5)',
    '&:hover': {
			border: '1px solid #6667AB',
      backgroundColor: 'rgba(102, 103, 171, 0.2)'
		},
  },
  error: {}
});

interface IProps {
  notification: any,
  apolloClient: any,
  history: any,
  classes: any;
  forgotPasswordRequest: (client: any, requestData: any, history: any) => void
}

interface IState {
  email: string,
  loading: boolean,
  errors: any,
  recaptchaError: any,
  accountVeryfied: boolean,
  resendLinkLoding: boolean,
  emailSent: boolean,
  [key: string]: any,
  errorMsg: string
}

class ForgotPassword extends Component<IProps, IState> {
  recaptcha: any;
  constructor(props: IProps) {
    super(props);

    this.state = {
      email: "",
      loading: false,
      errors: { email: "Error" },
      recaptchaError:false,
      accountVeryfied: false,
      resendLinkLoding: false,
      emailSent: false,
      errorMsg:""
    };
  }

  //  when receive updates from reducers
  UNSAFE_componentWillReceiveProps(props: IProps) {
    if (props.notification) {
      this.setState({ loading: false });
      if (this.state.resendLinkLoding) {
        this.setState({ accountVeryfied: false, resendLinkLoding: false })
      }
      if(props.notification.success){
        this.setState({emailSent:true})
      }
      if(props.notification.message && !props.notification.success) {
        this.setState({
          errorMsg: props.notification.message
        })
      }
    }
  }

  // when change input fields
  onChange = (event: any) => {
    const input = event.target.value
    const errors: any = {};
    //check email is empty and valid
    const validEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!input) {
      errors[event.target.name] = Messages.TENANT.ERROR.EMAIL.EMPTY;
    } else if (!validEmail.test(input)) {
      errors[event.target.name] = Messages.TENANT.ERROR.EMAIL.INVALID;
    } else {
      errors[event.target.name] = ""
    }

    this.setState({
      errors: {
        ...this.state.errors,
        [event.target.name]: errors[event.target.name]
      },
      [event.target.name]: event.target.value
    })
  }

  //submit form to send email
  onSubmit = () => {
    const requestData = {
      email: this.state.email,
    }
    const validateError = ValidateForm.validateForgotPasswordForm(requestData)
    if (!Object.keys(validateError).length && !this.state.recaptchaError) {
      this.setState({ errors: {}, recaptchaError:false })

      this.setState({ loading: true, errorMsg:""});
      this.props.notification.success = null
      this.props.notification.message = null
      this.props.forgotPasswordRequest(this.props.apolloClient.client, requestData, this.props.history);
    } else {
      this.setState({ errors: validateError })
    }
  }

  submitForm = (e: any) => {
    e.preventDefault();
    this.executeRecaptcha();
  }

  //execute Recaptcha
  executeRecaptcha() {
    this.recaptcha.execute()
  }

  // submit form after validate recaptcha
  validateRecaptcha = () => {
    this.setState({
      recaptchaError:false
    },() => this.onSubmit())
  }

  render() {
    const { classes } = this.props;
    const { emailSent, errorMsg, loading } = this.state;

    const options = {
      decodeEntities: true,
    };
    return (
      <React.Fragment>
        <Helmet title="Forgot Password"/>

        <div className={classes.layout}>
          {
            emailSent ? (

              <Grid container spacing={3}>
                 <Grid item xs={12} sm={6}  style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <img src="/assets/images/lively/meeting_02.png" />
              </Grid>
              
              <Grid item xs={12} sm={6}>
              <Box className={classes.mainDescription}>

                <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)}>We call this a known unknown...</Typography>

                <p className={classes.description}>We&#39;re looking through our system to find the Immersion account for <strong className={classes.description2}>{this.state.email}</strong></p>
                
                <div className="login-form">
                  <p className={classes.description}>In the next few minutes you should receive an email with instructions for resetting your password. If you don&#39;t get the email soon, make sure you entered the correct email address and double check your spam folder.
                  
                  </p>

                  <p className={classes.gotologin} style={{}}>Go back to <Link className={classes.resendlink} to="/user/login">Sign in</Link></p>
                </div>
              </Box>
              </Grid>
              </Grid>
            ) : (
              <Grid container spacing={3}>
              <Grid item xs={12} sm={6} >
              <Box className={classes.mainDiv}>
              <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)}>We get it. Passwords can kinda suck.</Typography>
                
                <p className={classes.description_title2} style={{ marginBottom: 20, color: '#19191e' }}>No worries. Enter your email and we&#39;ll send you a link to reset it.</p>
                <div className="login-form">
                  <form onSubmit={this.submitForm}>
                    <TextField
                      InputLabelProps={{
                        classes: {
                          root: classes.label,
                          focused: classes.focusedLabel,
                          error: classes.erroredLabel
                        },
                      }}
                      InputProps={{
                        classes: {
                          root: classes.underline,
                          error: classes.error
                        }
                      }}
                      margin="normal"
                      style={{ width: '100%' }}
                      id="email"
                      label="Enter Email Address"
                      name="email"
                      autoComplete="email"
                      onChange={this.onChange}
                    />
                    <Button
                      type="submit"
                      color="secondary"
                      variant="outlined"
                      className={classes.resetBtn}
                      disabled={this.state.loading || (this.state.errors && this.state.errors.email ? true : false)}
                    >
                      {loading && <CircularProgress color="inherit" size={20}/>}
                      { !loading && <p style={(this.state.errors && this.state.errors.email) ? {} : {}}>Reset your password</p>}
                    </Button>
                    { errorMsg && <Alert icon={false} className="error-alert" severity="error">{ ReactHtmlParser(errorMsg, options) }</Alert> }
                  </form>
                  <Recaptcha
                    ref={ (ref: any) => this.recaptcha = ref }
                    sitekey= {Config.RECAPTCHA_SITE_KEY}
                    onResolved={this.validateRecaptcha}
                    onError={()=>this.setState({recaptchaError:Messages.NOTIFICATIONS.ERROR.recaptchaVerificationFail})}
                    onExpired={()=>this.setState({recaptchaError:Messages.NOTIFICATIONS.ERROR.recaptchaExpired})}
                  />
                  <p style={{ marginTop:22, color: '#19191e' }}>Go back to <Link to="/user/login" style={{color: '#19191e', textDecoration: 'underline'}}>Sign in</Link></p>
                </div>
              </Box>
              </Grid>
              </Grid>
              )
          }
        </div>
        
      </React.Fragment>
    );
  }
}

// load reducers
const mapStateToProps = (state: any) => ({
  authUser: state.authUser,
  apolloClient: state.apolloClient,
  notification: state.notification
});

// load actions
const mapDispatchToProps = (dispatch: any) => {
  return {
    forgotPasswordRequest: (client: any, request: any) => { dispatch(actions.forgotPasswordRequest(client, request)); },
  };
};

const WondrForgotPasswordComponent = withStyles(useStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword));

export {
  WondrForgotPasswordComponent
}
